import React, { useState } from "react";
import {
  AppBar,
  Box,
  Collapse,
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";
import { Link as RouterLink } from "react-router-dom";
import { useAppSelector } from "src/redux/hooks";
import { ChildMenuProps, ParentMenuProps } from "src/redux/menu/menuSlice";
import { GetSubMenuItemTranslation } from "../util/menuAndSubMenuList/menuAndSubMenuList";
import AccountMenu from "./accountMenu";

interface AuthInnerNavbarProps {
  children?: React.ReactNode;
}

const AuthInnerNavbar: React.FC<AuthInnerNavbarProps> = ({ children }) => {
  const menuList = useAppSelector(
    (state: { menu: { menuList: { Data: ParentMenuProps[] } } }) =>
      state.menu.menuList
  );

  const IsCRMLogin = localStorage.getItem("IsCRMLogin")
  const [subMenuOpen, setSubMenuOpen] = useState<{ [key: number]: boolean }>(
    {}
  );

  const handleClickListItem = (index: number) => {
    setSubMenuOpen((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <Box sx={{ display: "flex" }}>
      <Box>
        <AppBar
          position="fixed"
          sx={{
            bgcolor: "#000",
            borderBottom: "1px solid rgb(58, 58, 58)",
            boxShadow:
              "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
          }}
        >
          <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography component={RouterLink} to="/">
              <img src="logo.png" alt="logo" style={{ width: "100px", marginTop: '10px', }} />
            </Typography>

            <List sx={{ display: "flex" }}>
              {menuList?.Data?.map((menuItem, index) => (
                <Box key={index} sx={{ mx: 1 }}>
                  <ListItemButton style={{ fontFamily: 'Poppins', }}
                    onClick={
                      menuItem.Children && menuItem.Children.length > 0
                        ? () => handleClickListItem(index)
                        : undefined
                    }
                    component={menuItem.Children.length === 0 ? (RouterLink as any) : "div"}

                    to={menuItem.Children.length === 0 ? menuItem.Url : ""}
                    sx={{
                      color: "#acacac",
                      fontFamily: 'Poppins',
                      padding: '3px 16px',
                      borderRadius: '100px',
                      "&:hover": {
                        bgcolor: "#222",
                      },
                    }}
                  >
                    <ListItemText
                      primary={menuItem.Name}
                      sx={{ whiteSpace: "nowrap" }}
                    />
                    {menuItem.Children.length > 0 &&
                      (subMenuOpen[index] ? <ExpandLess /> : <ExpandMore />)}
                  </ListItemButton>

                  {menuItem.Children.length > 0 && (
                    <Collapse in={subMenuOpen[index]} timeout="auto" unmountOnExit>
                      <List disablePadding sx={{ pl: 2 }}>
                        {menuItem.Children.map((subItem, subIndex) => (
                          <ListItemButton
                            key={subIndex}
                            component={RouterLink}
                            to={subItem.Url}
                            sx={{
                              color: "#ddd",
                              fontFamily: 'Poppins',
                              "&:hover": {
                                color: "#acacac",
                                bgcolor: "#333",
                              },
                            }}
                          >
                            <ListItemIcon>
                              <img
                                src={
                                  GetSubMenuItemTranslation(subItem.Name)?.icon ??
                                  "default-icon.png"
                                }
                                alt=""
                                width="24px"
                                height="24px"
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                GetSubMenuItemTranslation(subItem.Name)?.text ??
                                subItem.Name
                              }
                            />
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </Box>
              ))}
            </List>
            {IsCRMLogin === "true" && (
              <Box>
                <AccountMenu />
              </Box>
            )}

          </Toolbar>
        </AppBar>
      </Box>

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          background: "#000",
          p: 2,
          mt: "66px",
          maxHeight: "calc(100vh - 66px)",
          overflow: "auto",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default AuthInnerNavbar;
